import { ActionParamRow } from "@/helpers/aiActions/aiActions.helpers.decl";

const INDENT_REM_PER_DEPTH = 0.75;

type TranscriptionAIActionParamsProps = {
  label: string;
  rows: ActionParamRow[];
};

export function TranscriptionAIActionParams({
  label,
  rows,
}: TranscriptionAIActionParamsProps) {
  return (
    <div className="flex flex-col text-sm">
      <span className="font-medium text-foreground">{label}</span>
      {rows.map((row) => (
        <div
          key={row.id}
          className="text-muted-foreground"
          style={{
            paddingLeft: `${row.depth * INDENT_REM_PER_DEPTH}rem`,
          }}
        >
          {row.label}:{" "}
          {row.kind === "value" && (
            <span className="break-all">{row.text}</span>
          )}
          {row.kind === "empty" && <span>—</span>}
        </div>
      ))}
    </div>
  );
}
